<svg width="133" height="1" viewBox="0 0 133 1" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0.5H133" stroke="url(#paint0_linear_6007_1688)"/>
<defs>
<linearGradient id="paint0_linear_6007_1688" x1="0" y1="1" x2="133" y2="1" gradientUnits="userSpaceOnUse">
<stop stop-color="#121212"/>
<stop offset="1" stop-color="#121212" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
